import React, { ComponentType } from 'react';
import { Badge, BadgeProps, Typography } from 'glints-aries/es/@next';
import { borderRadius8 } from 'glints-aries/es/@next/utilities/borderRadius';
import { Neutral } from 'glints-aries/es/@next/utilities/colors';
import { space8 } from 'glints-aries/es/@next/utilities/spacing';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

type PromoBannerProps = {
  percentage: number;
};

const DefaultBadge = styled(Badge)`
  border-radius: ${borderRadius8};
  margin-top: ${space8};
`;
const CutOutBadge = styled(Badge)`
  border-radius: ${borderRadius8};
  border-top-right-radius: 0;
  border-bottom-left-radius: 0;
  margin-top: 0;
`;

function DefaultBanner({
  percentage,
  wrapper,
}: PromoBannerProps & {
  wrapper?: ComponentType<BadgeProps>;
}) {
  const Wrapper = wrapper ?? DefaultBadge;
  return (
    <Wrapper status="enticing">
      <Typography variant="subtitle2" color={Neutral.B100}>
        <FormattedMessage
          id="text-limited-time-discount"
          defaultMessage="{discountCount}% Off · Limited-Time Offer"
          values={{
            discountCount: percentage,
          }}
        />
      </Typography>
    </Wrapper>
  );
}

function CutOutBanner(props: Pick<PromoBannerProps, 'percentage'>) {
  return <DefaultBanner {...props} wrapper={CutOutBadge} />;
}

export default Object.assign(DefaultBanner, {
  DefaultBanner,
  CutOutBanner,
});
